import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateEventSchedule } from '../../../actions/draw-edit-actions';
import EventDeskTabLayout from '../EventDeskTabLayout';
import { scheduleTypeDescriptions } from '../ScheduleTab/ScheduleTypeOption';

import styles from './eventScheduleTypeSelection.scss';
import { getScheduleTypeValues } from '../../../utils/events';
import { useStatsig } from '../../../components/hooks/useStatsig';

const EventScheduleTypeSelection = () => {
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { event } = useSelector(({ drawEdit }) => {
        const { event } = drawEdit;
        return {
            event,
        };
    });

    const dispatch = useDispatch();
    const { checkGate: checkStatsigGate } = useStatsig();

    const { drawScheduleTypes } = coreUI.types.tms;

    const scheduleTypeValues = getScheduleTypeValues({
        sportTypeId: event?.data?.sportTypeId,
        drawScheduleTypes,
        scheduleTypeDescriptions,
        checkStatsigGate,
    });

    const onSetScheduleType = (newScheduleType) => {
        dispatch(updateEventSchedule(newScheduleType, true));
    };

    return (
        <EventDeskTabLayout showHeader={false} className={`${styles.scheduleTypeSelection} container`}>
            <div className={styles.content}>
                <h4 className={styles.title} data-testid="draw-edit.schedule-type-selection.title">
                    Welcome to Event Desk
                </h4>
                <p className={`${styles.subTitle} mb24`} data-testid="draw-edit.schedule-type-selection.subtitle">
                    How would you like your match schedule to be managed? You can always change this in your settings.
                </p>
                <div className={styles.optionsContainer}>
                    {scheduleTypeValues.map((scheduleType) => (
                        <div
                            key={`schedule-type-${scheduleType.id}`}
                            className={styles.option}
                            data-testid={`draw-edit.schedule-type-selection.option-${scheduleType.id}`}
                        >
                            <div className={styles.label} data-testid={`draw-edit.schedule-type-selection.option-${scheduleType.id}.label`}>
                                {scheduleType.label}
                            </div>
                            <div className={`${styles.description} mt8 ${scheduleType.link ? 'mb0' : 'mb16'}`} data-testid={`draw-edit.schedule-type-selection.option-${scheduleType.id}.description`}>
                                {scheduleType.description}
                            </div>
                            {scheduleType.link && (
                                <div className={`${styles.description} mt8 mb16`}>
                                    {scheduleType.linkDescription}
                                    <a target="_blank" rel="noopener noreferrer" href={scheduleType.link} onClick={e => e.stopPropagation()} data-testid={`draw-edit.schedule-type-selection.option-${scheduleType.id}.learn-more-link`}> here</a>
                                </div>
                            )}
                            <button
                                className={`btn btn-primary text-uppercase ${styles.chooseButton}`}
                                type="button"
                                onClick={() => onSetScheduleType(scheduleType)}
                                data-testid={`draw-edit.schedule-type-selection.option-${scheduleType.id}.choose-btn`}
                            >
                                Choose
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </EventDeskTabLayout>
    );
};

EventScheduleTypeSelection.defaultProps = {};

export default EventScheduleTypeSelection;
